package com.patronat.top.ui.models

data class VenueServiceItemData(
    val id: String,
    val name: String = "",
    val price: String = "",
    val currency: String = "",
    val description: String = "",
    val hasError: Boolean = false
)
